import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

import { Page } from 'components';
import { BUILD_VERSION } from 'settings';

import useStyles from './styles';

function LayoutAuth({ children, title }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Page maxWidth="lg" title={title} className={classes.bg}>
        <div className={classes.bgFullHeight}>

          {children}

        </div>
      </Page>

      <footer className={classes.footer}>
        <Box lg={12} display="flex" alignItems="center" className={classes.footer_cont}>
          <div className={classes.footer_text}>
            <Typography
              children={`Versión ${BUILD_VERSION}`}
              variant="caption" />
          </div>
        </Box>
      </footer>

    </div>
  );
};

LayoutAuth.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default LayoutAuth;
